import { formatCount, formatUtcDate } from './format';

// One description of a query, used by the recent-runs list and by the collapsed form. Both answer
// the same question — "what was asked for?" — and they must not answer it two different ways.
//
// Takes dates or ISO strings, since the form holds Date objects and a stored run holds strings.
export const summarizeScope = ({ from, to, companies, slim } = {}) => {
  const parts = [];
  const fromLabel = from ? formatUtcDate(from) : null;
  const toLabel = to ? formatUtcDate(to) : null;

  if (fromLabel && toLabel) parts.push(`${fromLabel} → ${toLabel}`);
  else if (fromLabel) parts.push(`from ${fromLabel}`);
  else if (toLabel) parts.push(`to ${toLabel}`);
  else parts.push('All history');

  const list = companies || [];
  if (list.length === 1) {
    const only = list[0];
    parts.push(only.symbol || only.name || '1 company');
  } else if (list.length > 1) {
    parts.push(`${formatCount(list.length)} companies`);
  }

  if (slim) parts.push('score-only');

  return parts.join(' · ');
};
